import React from 'react'
import PropTypes from 'prop-types'

function SmartviewText (props) {
  const {
    children,
    label,
    textSize,
    className = '',
    outerClassName = '',
    onClick = () => {}
  } = props

  const labelElement = label ? <div className='font-medium text-base mb-1 flex justify-between'>{label}</div> : null
  const classNames = ['text-gray-500', 'group', 'space-y-1', textSize, className]

  return (
    <div className={'smartview-text ' + outerClassName} onClick={onClick}>
      {labelElement}
      <div className={classNames.join(' ')}>
        {children}
      </div>
    </div>
  )
}

SmartviewText.defaultProps = {
  label: null,
  textSize: 'text-sm'
}

SmartviewText.propTypes = {
  label: PropTypes.node
}

export default SmartviewText
